import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function BackButton(props) {
  const navigate = useNavigate();
  const { action, className, iconStyle  } = props;

  const btnStyle = {
    width: '38px',
    minWidth: '38px',
    height: '38px',
    borderRadius: '50%',
    boxShadow: '1px 1px 10px 0px #0000001A, -2px -2px 7px 0px #FFFFFF',
    cursor: 'pointer',
    border: '1px solid #ffffff',
    background: '#F5F5F5',
    ...className
  };

  const IconStyle = {
    fontSize: 23,
    color: '#707070',
    ...iconStyle
  };

  const onClickHandler = ()=> {
    if ( action) return action();
    navigate(-1)
  }

  return (
    <Button sx={btnStyle} onClick={onClickHandler}>
      <ArrowBackIcon style={IconStyle} />
    </Button>
  );
}
